<template>
<div>
  <main-header-nav
     :title="'用户列表'"
     :content="'更新用户信息'"
     :goBack="goBack">
  </main-header-nav>
  <el-card
    v-loading="loading"
    style="width: 500px;margin: 30px auto;padding: 30px 10px 10px 10px;"
  >
    <user-form
      :type="type"
      :userForm="editForm"
      :orgnizations="orgnizations"
      :roles="roles"
      :rules="rules"
    >
    </user-form>
  </el-card>
</div>
</template>
<script>
import UserForm from './UserForm.vue'
import MainHeaderNav from '../common/MainHeaderNav'
export default {
  components: {
    UserForm, MainHeaderNav
  },
  data () {
    var self = this
    var validateOrgnization = (rule, value, callback) => {
      if (self.editForm.orgnization.id === undefined) {
        callback(new Error('组织不能为空'))
      } else {
        callback()
      }
    }
    var validateRole = (rule, value, callback) => {
      if (self.editForm.role.id === undefined) {
        callback(new Error('角色不能为空'))
      } else {
        callback()
      }
    }
    return {
      type: 'edit',
      rules: {
        orgnizationId: [
          {
            validator: validateOrgnization,
            trigger: ['blur', 'change']
          }
        ],
        roleId: [
          {
            validator: validateRole,
            trigger: ['blur', 'change']
          }
        ],
        username: [
          { required: true, message: '用户名不能为空', trigger: 'blur' }
        ],
        nickName: [{ required: true, message: '昵称不能为空', trigger: 'blur' }]
      },
      orgnizations: [],
      roles: [],
      editForm: {
        username: '',
        nickName: '',
        role: {},
        orgnization: {}
      },
      loading: false
    }
  },

  computed: {
    user () {
      return this.$store.state.user
    }
  },

  mounted () {
    var self = this
    self.$data.loading = true
    var requestCount = 0
    var requestComplete = function () {
      requestCount++
      if (requestCount === 2) {
        self.getRequest('/users/' + self.$route.params.id)
          .then(resp => {
            if (resp && resp.result) {
              self.$data.loading = false
              self.$data.editForm = resp.result
            }
          })
      }
    }
    if (this.user.role.id === 3) {
      this.$data.editForm.orgnization.id = this.user.orgnization.id
      this.$data.orgnizations = [this.user.orgnization]
      requestCount++
    } else {
      this.getRequest('/orgnizations')
        .then(resp => {
          if (resp && resp.result) {
            self.$data.orgnizations = resp.result
            requestComplete()
          }
        })
    }

    this.getRequest('/roles')
      .then(resp => {
        if (resp && resp.result) {
          var result = []
          for (var i = 0; i < resp.result.length; i++) {
            if (this.user.role.id < resp.result[i].id) {
              // if (resp.result[i].id === 2 && self.$data.editForm.role.id !== 2) {
              //   continue
              // }
              result.push(resp.result[i])
            }
          }
          self.$data.roles = result
          if (self.user.role.id === 3) {
            self.$data.editForm.role.id = 4
          }
          requestComplete()
        }
      })
  },

  methods: {
    goBack () {
      this.$router.replace('/users')
    }
  }
}
</script>
<style></style>
